import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "desktop-nav-shell d-none d-md-flex ml-6" }
const _hoisted_2 = { class: "mobile-drawer-header" }
const _hoisted_3 = {
  key: 0,
  class: "mobile-quick-actions"
}
const _hoisted_4 = { class: "editor-shell mb-2" }
const _hoisted_5 = { class: "editor-toolbar" }
const _hoisted_6 = { class: "editor-body" }
const _hoisted_7 = { class: "editor-shell mb-2" }
const _hoisted_8 = { class: "editor-toolbar" }
const _hoisted_9 = { class: "editor-body" }
const _hoisted_10 = { class: "d-flex align-center ga-2 flex-wrap" }
const _hoisted_11 = { class: "text-caption text-medium-emphasis" }
const _hoisted_12 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_13 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_14 = {
  key: 1,
  class: "mt-3 map-image-preview-wrap"
}
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "d-flex align-center ga-2 flex-wrap" }
const _hoisted_17 = { class: "text-caption text-medium-emphasis" }
const _hoisted_18 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_19 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_20 = {
  key: 1,
  class: "mt-3 map-image-preview-wrap"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_23 = {
  key: 0,
  class: "text-caption text-medium-emphasis mt-1"
}
const _hoisted_24 = { class: "editor-shell mb-4" }
const _hoisted_25 = { class: "editor-toolbar" }
const _hoisted_26 = { class: "editor-body" }
const _hoisted_27 = { class: "d-flex align-center ga-2" }
const _hoisted_28 = { class: "text-caption text-grey" }
const _hoisted_29 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_30 = { class: "text-caption text-medium-emphasis mt-1" }
const _hoisted_31 = {
  key: 1,
  class: "image-gallery mt-3"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "image-caption" }
const _hoisted_34 = { class: "image-thumb-actions" }
const _hoisted_35 = { class: "image-config-row" }
const _hoisted_36 = ["value", "onInput"]
const _hoisted_37 = { class: "image-align-row" }
const _hoisted_38 = {
  key: 2,
  class: "text-caption text-medium-emphasis mt-2"
}
const _hoisted_39 = { class: "d-flex justify-end mt-2" }
const _hoisted_40 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_41 = {
  key: 1,
  class: "d-flex flex-column ga-2"
}

import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { useTheme } from "vuetify";
import api from "@/api";

// Router & Store
type EditorToolbarState = {
  bold: boolean;
  italic: boolean;
  underline: boolean;
  unorderedList: boolean;
  orderedList: boolean;
  h2: boolean;
  h3: boolean;
};

type ImageAlign = "left" | "center" | "right";
type ImageInsertOption = { width: number; align: ImageAlign };

const MAX_UPLOAD_IMAGE_EDGE = 1920;
const IMAGE_UPLOAD_QUALITY = 0.82;
const BLOG_IMAGE_MAX_COUNT = 30;


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

// Vuetify Theme
const theme = useTheme();
const themeIcon = ref("");

// App State
const activeTab = ref<string | number | null>(null);
const drawer = ref(false);
const isProfileActive = ref(false);

// Dialogs
const showGameDialog = ref(false);
const showMapDialog = ref(false);
const menuEndOfApplyPicker = ref(false);
const menuGameDatePicker = ref(false);
// HOZZÁADVA: Blogbejegyzés dialógus
const showPostDialog = ref(false);
const showCategoryManagerDialog = ref(false);
const postImagesInput = ref<HTMLInputElement | null>(null);
const mapImageInput = ref<HTMLInputElement | null>(null);
const gameDescriptionEditor = ref<HTMLDivElement | null>(null);
const mapDescriptionEditor = ref<HTMLDivElement | null>(null);
const createDefaultToolbarState = (): EditorToolbarState => ({
  bold: false,
  italic: false,
  underline: false,
  unorderedList: false,
  orderedList: false,
  h2: false,
  h3: false,
});

const gameEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
const mapEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
const availableEventGroups = ref<Array<{ id: number; name: string }>>([]);

// New Game & Map State
const today = new Date().toISOString().substr(0, 10);
const tempEndOfApplyDate = ref<string | null>(null);
const tempEndOfApplyTime = ref<string | null>(null);

const tempGameDate = ref<string | null>(null);
const tempGameTime = ref<string | null>(null);

const newGame = ref({
  name: "",
  description: "",
  date: "",
  mapId: null as string | null,
  endOfApply: "",
  maxParticipants: 0,
  allowedGroupIds: [] as number[],
  sendNotificationEmails: true, // Új mező, alapértelmezett érték true
});

const newMap = ref({
  name: "",
  description: "",
  address: "",
  contactPage: "",
  imageUrl: "",
});

const selectedMapImage = ref<File | null>(null);
const mapImagePreview = ref("");
const isMapSubmitting = ref(false);
const mapUploadProgress = ref(0);

// Bejegyzés modell
const newPost = ref({
  title: "",
  content: "",
  imageUrl: "",
  categories: [] as string[],
});

// Kategóriák
const blogCategories = ref<Array<{ id: number; name: string }>>([]);
const isCategoryDeleting = ref(false);
const availableCategories = ref<string[]>([
  "Hírek",
  "Események",
  "Fejlesztés",
  "Élmény beszámoló",
  "Privát játék",
  "Publikus játék",
]);

// Computed State
const alert = computed(() => store.state.alert);
const snackbar = computed(() => store.state.snackbar);
const confirmDialog = computed(() => store.state.confirmDialog);
const profile = computed(() => store.state.profile);
const maps = computed(() => store.state.maps);
const canViewStatistics = ref(false);

const formattedEndOfApplyDate = computed(() => {
  if (!newGame.value.endOfApply) return "";
  const d = new Date(newGame.value.endOfApply);
  return d.toLocaleString("hu-HU", {
    timeZone: "Europe/Budapest",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
});

const formattedGameDate = computed(() => {
  if (!newGame.value.date) return "";
  const d = new Date(newGame.value.date);
  return d.toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
  });
});

// Methods
function toggleTheme() {
  theme.global.name.value = theme.global.current.value.dark ? "light" : "dark";
  themeIcon.value =
    theme.global.name.value === "dark"
      ? "mdi-weather-sunny"
      : "mdi-weather-night";
  localStorage.setItem("currentTheme", theme.global.name.value);
}

async function logoutUser() {
  try {
    const request = await store.dispatch("deleteProfileData");
    store.commit("SET_PROFILE", null);
    activeTab.value = 0;
    router.push({ name: "forum-page" });
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: request.responseData.responseMessage,
      color: "success",
    });
  } catch {
    store.commit("SET_PROFILE", null);
    activeTab.value = 0;
    router.push({ name: "login-page" });
  }
}

function goToProfile() {
  isProfileActive.value = true;
  activeTab.value = null;
  router.push({ name: "profile-page" });
}

function resetProfileActive() {
  isProfileActive.value = false;
}

function isRouteActive(routeNames: string[]) {
  return routeNames.includes(String(route.name || ""));
}

async function openGameDialog(closeDrawer = false) {
  if (!Array.isArray(maps.value) || maps.value.length === 0) {
    try {
      await store.dispatch("fetchMaps");
    } catch (error) {
      console.error("Pályák előtöltése sikertelen:", error);
    }
  }

  if (availableEventGroups.value.length === 0) {
    try {
      const groups = await store.dispatch("getGroups");
      availableEventGroups.value = Array.isArray(groups)
        ? groups.map((group: any) => ({
            id: Number(group.id),
            name: String(group.name || ""),
          }))
        : [];
    } catch (error) {
      console.error("Csapatok előtöltése sikertelen:", error);
    }
  }

  showGameDialog.value = true;
  if (closeDrawer) {
    drawer.value = false;
  }
}

function saveGameDateTime() {
  if (!tempGameDate.value || tempGameTime.value === null) {
    store.dispatch("setAlert", {
      error: "Kérlek, add meg a játék dátumát, óráját és percét is!",
    });
    return;
  }

  try {
    // A tempEndOfApplyDate.value stringként érkezik pl. '2025-04-29', ezért új Date objektumot csinálunk
    const dateObj = new Date(tempGameDate.value);
    if (isNaN(dateObj.getTime())) {
      throw new Error("Érvénytelen dátum formátum.");
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const time = tempGameTime.value;

    // Mentés az új formátumban (YYYY-MM-DD HH:mm) - JAVÍTVA
    newGame.value.date = `${year}. ${month}. ${day}. ${time}`;
    menuGameDatePicker.value = false;
  } catch (error) {
    console.error("Hiba a dátum feldolgozása közben:", error);
    store.dispatch("setAlert", {
      error: "Hiba történt a dátum formázása közben.",
    });
  }
}

function saveEndOfApplyDate() {
  if (!tempEndOfApplyDate.value || tempEndOfApplyTime.value === null) {
    store.dispatch("setAlert", {
      error:
        "Kérlek, add meg a jelentkezési határidő dátumát, óráját és percét is!",
    });
    return;
  }

  try {
    // A tempEndOfApplyDate.value stringként érkezik pl. '2025-04-29', ezért új Date objektumot csinálunk
    const dateObj = tempEndOfApplyDate.value; // Ez egy Date objektum
    const timeObj = tempEndOfApplyTime.value; // Pl.: "15:15"

    if (isNaN(dateObj.getTime())) {
      throw new Error("Érvénytelen dátum formátum.");
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    const dateTime = `${year}.${month}.${day} ${timeObj}`; // ISO 8601

    // // Mentés az új formátumban (YYYY-MM-DD HH:mm)
    newGame.value.endOfApply = dateTime;
    menuEndOfApplyPicker.value = false;
  } catch (error) {
    console.error("Hiba a dátum feldolgozása közben:", error);
    store.dispatch("setAlert", {
      error: "Hiba történt a dátum formázása közben.",
    });
  }
}

function queryCommandStateSafe(command: string): boolean {
  try {
    return document.queryCommandState(command);
  } catch {
    return false;
  }
}

function getActiveBlockTag(editor: HTMLDivElement | null): string {
  if (!editor) return "";
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return "";
  const anchor = selection.anchorNode;
  if (!anchor || !editor.contains(anchor)) return "";

  let current: HTMLElement | null =
    anchor.nodeType === Node.TEXT_NODE
      ? anchor.parentElement
      : (anchor as HTMLElement);

  while (current && editor.contains(current)) {
    const tag = current.tagName?.toLowerCase();
    if (tag === "h2" || tag === "h3") return tag;
    current = current.parentElement;
  }
  return "";
}

function refreshEditorToolbarState(
  editor: HTMLDivElement | null,
  target: { value: EditorToolbarState }
) {
  if (!editor) {
    target.value = createDefaultToolbarState();
    return;
  }

  const selection = window.getSelection();
  const anchor = selection?.anchorNode;
  const inEditor = Boolean(anchor && editor.contains(anchor));
  if (!inEditor) {
    target.value = createDefaultToolbarState();
    return;
  }

  const block = getActiveBlockTag(editor);
  target.value = {
    bold: queryCommandStateSafe("bold"),
    italic: queryCommandStateSafe("italic"),
    underline: queryCommandStateSafe("underline"),
    unorderedList: queryCommandStateSafe("insertUnorderedList"),
    orderedList: queryCommandStateSafe("insertOrderedList"),
    h2: block === "h2",
    h3: block === "h3",
  };
}

const onEditorSelectionChange = () => {
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
};

function syncGameDescriptionToModel() {
  newGame.value.description = gameDescriptionEditor.value?.innerHTML || "";
}

function onGameDescriptionInput() {
  syncGameDescriptionToModel();
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
}

function applyGameEditorCommand(command: string, value?: string) {
  const editor = gameDescriptionEditor.value;
  if (!editor) return;
  editor.focus();
  document.execCommand(command, false, value);
  syncGameDescriptionToModel();
  refreshEditorToolbarState(
    gameDescriptionEditor.value,
    gameEditorToolbarState
  );
}

function syncMapDescriptionToModel() {
  newMap.value.description = mapDescriptionEditor.value?.innerHTML || "";
}

function onMapDescriptionInput() {
  syncMapDescriptionToModel();
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
}

function applyMapEditorCommand(command: string, value?: string) {
  const editor = mapDescriptionEditor.value;
  if (!editor) return;
  editor.focus();
  document.execCommand(command, false, value);
  syncMapDescriptionToModel();
  refreshEditorToolbarState(mapDescriptionEditor.value, mapEditorToolbarState);
}

async function createGame() {
  syncGameDescriptionToModel();
  try {
    const safeName = String(newGame.value.name || "").trim();
    const safeDescription = String(newGame.value.description || "").trim();
    const safeDate = String(newGame.value.date || "").trim();
    const safeEndOfApply = String(newGame.value.endOfApply || "").trim();
    const safeMapId = String(newGame.value.mapId || "").trim();
    const safeMaxParticipants = Number(newGame.value.maxParticipants || 0);
    const safeAllowedGroupIds = Array.from(
      new Set(
        (Array.isArray(newGame.value.allowedGroupIds)
          ? newGame.value.allowedGroupIds
          : []
        )
          .map((value) => Number(value))
          .filter((value) => Number.isInteger(value) && value > 0)
      )
    );

    if (!safeName || safeName.length < 3) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A játék nevének legalább 3 karakteresnek kell lennie.",
        color: "error",
      });
      return;
    }
    if (!safeDescription) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A játék leírása kötelező.",
        color: "error",
      });
      return;
    }
    if (!safeDate || !safeEndOfApply || !safeMapId) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "Időpont, jelentkezési határidő és pálya kiválasztása kötelező.",
        color: "error",
      });
      return;
    }
    if (!Number.isFinite(safeMaxParticipants) || safeMaxParticipants < 2) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A maximális résztvevőszám minimum 2 fő.",
        color: "error",
      });
      return;
    }

    const payload = {
      name: safeName,
      description: safeDescription,
      date: safeDate,
      mapId: safeMapId,
      endOfApply: safeEndOfApply,
      maxParticipants: Math.round(safeMaxParticipants),
      allowedGroupIds: safeAllowedGroupIds,
      sendNotificationEmails: Boolean(newGame.value.sendNotificationEmails),
    };

    const response = await store.dispatch("addEvent", payload);
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: response,
      color: "success",
    });
    showGameDialog.value = false;
    newGame.value = {
      name: "",
      description: "",
      date: "",
      mapId: null,
      endOfApply: "",
      maxParticipants: 0,
      allowedGroupIds: [],
      sendNotificationEmails: true,
    };
    if (gameDescriptionEditor.value) {
      gameDescriptionEditor.value.innerHTML = "";
    }
    store.dispatch("fetchEvents");
  } catch (error: any) {
    console.error("Hiba pálya létrehozásakor:", error.message);
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text: error.message || "Nem sikerült létrehozni a pályát.",
      color: "error",
    });
  }
}

async function createMap() {
  syncMapDescriptionToModel();
  isMapSubmitting.value = true;
  mapUploadProgress.value = 0;
  try {
    const safeName = String(newMap.value.name || "").trim();
    const safeAddress = String(newMap.value.address || "").trim();
    const safeDescription = String(newMap.value.description || "").trim();
    const safeContactPage = String(newMap.value.contactPage || "").trim();
    const safeImageUrl = String(newMap.value.imageUrl || "").trim();
    const hasValidImageUrl =
      safeImageUrl.length > 0
        ? /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(safeImageUrl)
        : false;

    if (!safeName || safeName.length < 2) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya neve kötelező (minimum 2 karakter).",
        color: "error",
      });
      return;
    }
    if (!safeAddress) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya címe kötelező.",
        color: "error",
      });
      return;
    }
    if (!safeDescription) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A pálya leírása kötelező.",
        color: "error",
      });
      return;
    }
    if (
      safeContactPage &&
      !/^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(safeContactPage)
    ) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A kapcsolat linkje csak érvényes http/https URL lehet.",
        color: "error",
      });
      return;
    }
    if (!selectedMapImage.value && safeImageUrl && !hasValidImageUrl) {
      store.dispatch("setSnackbar", {
        title: "Hiba",
        text: "A kép URL formátuma érvénytelen.",
        color: "error",
      });
      return;
    }

    const payload = new FormData();
    payload.append("name", safeName);
    payload.append("address", safeAddress);
    payload.append("description", safeDescription);
    payload.append("contactPage", safeContactPage);

    if (selectedMapImage.value) {
      payload.append("image", selectedMapImage.value);
    } else if (safeImageUrl) {
      payload.append("imageUrl", safeImageUrl);
    }

    await api.post("/maps/new", payload, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const total = Number(event?.total || 0);
        const loaded = Number(event?.loaded || 0);
        if (total > 0) {
          mapUploadProgress.value = Math.min(
            100,
            Math.max(1, Math.round((loaded / total) * 100))
          );
        } else {
          mapUploadProgress.value = 0;
        }
      },
    });

    store.dispatch("setSnackbar", {
      title: "Pálya létrehozva",
      text: "Sikeres pálya létrehozás!",
      color: "success",
    });
    showMapDialog.value = false;
    resetMapForm();
    store.dispatch("fetchMaps");
  } catch (error: any) {
    console.error("Hiba pálya létrehozásakor:", error.message);
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text: error.message || "Nem sikerült létrehozni a pályát.",
      color: "error",
    });
  } finally {
    isMapSubmitting.value = false;
    mapUploadProgress.value = 0;
  }
}

async function onMapImageSelect(event: Event) {
  const input = event.target as HTMLInputElement | null;
  if (!input?.files || input.files.length === 0) return;

  const file = input.files[0];
  const optimizedFile = await resizeImageFile(file);
  selectedMapImage.value = optimizedFile;
  if (mapImagePreview.value) {
    URL.revokeObjectURL(mapImagePreview.value);
  }
  mapImagePreview.value = URL.createObjectURL(optimizedFile);
  newMap.value.imageUrl = "";
  input.value = "";
}

function removeSelectedMapImage() {
  selectedMapImage.value = null;
  if (mapImagePreview.value) {
    URL.revokeObjectURL(mapImagePreview.value);
  }
  mapImagePreview.value = "";
}

function resetMapForm() {
  newMap.value = {
    name: "",
    description: "",
    address: "",
    contactPage: "",
    imageUrl: "",
  };
  if (mapDescriptionEditor.value) {
    mapDescriptionEditor.value.innerHTML = "";
  }
  mapEditorToolbarState.value = createDefaultToolbarState();
  removeSelectedMapImage();
}

const postContentEditor = ref<HTMLDivElement | null>(null);
const postEditorToolbarState = ref<EditorToolbarState>(
  createDefaultToolbarState()
);
const imagePreviews = ref<string[]>([]);
const selectedPostImages = ref<File[]>([]);
const selectedCoverImageIndex = ref<number | null>(null);
const imageInsertOptions = ref<Record<number, ImageInsertOption>>({});
const isBlogPostSubmitting = ref(false);
const blogUploadProgress = ref(0);
function getImageInsertOption(index: number): ImageInsertOption {
  const existing = imageInsertOptions.value[index];
  if (existing) return existing;
  const def: ImageInsertOption = { width: 45, align: "center" };
  imageInsertOptions.value[index] = def;
  return def;
}

function setImageAlign(index: number, align: ImageAlign) {
  const current = getImageInsertOption(index);
  imageInsertOptions.value[index] = { ...current, align };
}

function setImageWidth(index: number, width: number) {
  const current = getImageInsertOption(index);
  const safe = Math.min(90, Math.max(20, Number.isFinite(width) ? width : 45));
  imageInsertOptions.value[index] = { ...current, width: Math.round(safe) };
}

function setImageWidthFromEvent(index: number, event: Event) {
  const target = event.target as HTMLInputElement | null;
  if (!target) return;
  setImageWidth(index, Number(target.value));
}

function buildImageInsertStyle(width: number, align: ImageAlign) {
  const alignStyle =
    align === "left"
      ? "display:block;margin:16px auto 16px 0;"
      : align === "right"
      ? "display:block;margin:16px 0 16px auto;"
      : "display:block;margin:16px auto;";
  return `width:${width}%;max-width:100%;height:auto;object-fit:contain;border-radius:12px;${alignStyle}`;
}

function resolveImageInsertOptionFromNode(
  imgNode: HTMLImageElement,
  imageIndex: number
): ImageInsertOption {
  const existing = getImageInsertOption(imageIndex);
  const widthAttr = Number(imgNode.getAttribute("data-vsk-image-width"));
  const alignAttr = String(
    imgNode.getAttribute("data-vsk-image-align") || ""
  ).toLowerCase();
  const style = String(imgNode.getAttribute("style") || "");
  const widthFromStyle = Number(
    (style.match(/width:\s*(\d+(?:\.\d+)?)%/i) || [])[1]
  );

  const width = Number.isFinite(widthAttr)
    ? widthAttr
    : Number.isFinite(widthFromStyle)
    ? widthFromStyle
    : existing.width;

  let align: ImageAlign = existing.align;
  if (alignAttr === "left" || alignAttr === "center" || alignAttr === "right") {
    align = alignAttr;
  } else if (/margin:\s*[^;]*auto\s+[^;]*0;?/i.test(style)) {
    align = "left";
  } else if (/margin:\s*[^;]*0\s+[^;]*auto;?/i.test(style)) {
    align = "right";
  } else if (/margin:\s*[^;]*auto[^;]*;?/i.test(style)) {
    align = "center";
  }

  const resolved: ImageInsertOption = {
    width: Math.min(90, Math.max(20, Math.round(width))),
    align,
  };
  imageInsertOptions.value[imageIndex] = resolved;
  return resolved;
}

function syncEditorToModel() {
  newPost.value.content = postContentEditor.value?.innerHTML || "";
}

function onEditorInput() {
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function insertHtmlAtCursor(html: string) {
  const editor = postContentEditor.value;
  if (!editor) return;
  editor.focus();
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) {
    editor.insertAdjacentHTML("beforeend", html);
    syncEditorToModel();
    return;
  }
  const range = sel.getRangeAt(0);
  range.deleteContents();
  const temp = document.createElement("div");
  temp.innerHTML = html;
  const fragment = document.createDocumentFragment();
  let node = temp.firstChild;
  while (node) {
    const next = node.nextSibling;
    fragment.appendChild(node);
    node = next;
  }
  range.insertNode(fragment);
  range.collapse(false);
  sel.removeAllRanges();
  sel.addRange(range);
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function applyEditorCommand(command: string, value?: string) {
  const editor = postContentEditor.value;
  if (!editor) return;
  editor.focus();
  document.execCommand(command, false, value);
  syncEditorToModel();
  refreshEditorToolbarState(postContentEditor.value, postEditorToolbarState);
}

function serializeEditorContentForBackend() {
  const wrapper = document.createElement("div");
  wrapper.innerHTML = newPost.value.content || "";
  const images = wrapper.querySelectorAll("img");
  images.forEach((imgNode) => {
    const src = imgNode.getAttribute("src");
    if (!src) return;
    const imageIndex = imagePreviews.value.findIndex((url) => url === src);
    if (imageIndex < 0) return;
    const options = resolveImageInsertOptionFromNode(
      imgNode as HTMLImageElement,
      imageIndex
    );
    const token = `[[image:${imageIndex}|w:${options.width}|a:${options.align}]]`;
    imgNode.replaceWith(document.createTextNode(token));
  });
  return wrapper.innerHTML;
}

function refreshImagePreviews() {
  imagePreviews.value.forEach((url) => URL.revokeObjectURL(url));
  imagePreviews.value = selectedPostImages.value.map((file) =>
    URL.createObjectURL(file)
  );
}

async function resizeImageFile(
  file: File,
  maxEdge = MAX_UPLOAD_IMAGE_EDGE
): Promise<File> {
  if (!file.type.startsWith("image/")) return file;

  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error("A kép olvasása sikertelen."));
    reader.readAsDataURL(file);
  });

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error("A kép betöltése sikertelen."));
    image.src = dataUrl;
  });

  const longestEdge = Math.max(img.width, img.height);
  const ratio = longestEdge > maxEdge ? maxEdge / longestEdge : 1;
  const targetWidth = Math.max(1, Math.round(img.width * ratio));
  const targetHeight = Math.max(1, Math.round(img.height * ratio));

  if (ratio === 1) return file;

  const canvas = document.createElement("canvas");
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) return file;

  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const blob = await new Promise<Blob | null>((resolve) =>
    canvas.toBlob(resolve, "image/jpeg", IMAGE_UPLOAD_QUALITY)
  );

  if (!blob) return file;

  return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", {
    type: "image/jpeg",
  });
}

function setCoverImageIndex(index: number) {
  selectedCoverImageIndex.value = index;
}

function insertImageToEditor(index: number) {
  const previewUrl = imagePreviews.value[index];
  if (!previewUrl) return;
  const options = getImageInsertOption(index);
  const imageHtml = `<img src="${previewUrl}" alt="Blog kép ${
    index + 1
  }" class="inline-editor-image" data-vsk-image-index="${index}" data-vsk-image-width="${
    options.width
  }" data-vsk-image-align="${options.align}" style="${buildImageInsertStyle(
    options.width,
    options.align
  )}" />`;
  insertHtmlAtCursor(imageHtml);
}

// ----------------- image handling -----------------
async function onImageSelect(e: Event) {
  const input = e.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;
  const pickedFiles = Array.from(input.files);
  const remainingSlots = Math.max(
    0,
    BLOG_IMAGE_MAX_COUNT - selectedPostImages.value.length
  );
  if (remainingSlots <= 0) {
    store.dispatch("setSnackbar", {
      title: "Képlimit elérve",
      text: `Maximum ${BLOG_IMAGE_MAX_COUNT} képet adhatsz a bejegyzéshez.`,
      color: "warning",
    });
    input.value = "";
    return;
  }

  const acceptedFiles = pickedFiles.slice(0, remainingSlots);
  if (acceptedFiles.length < pickedFiles.length) {
    store.dispatch("setSnackbar", {
      title: "Képlimit",
      text: `A megengedett képlimit miatt csak ${acceptedFiles.length} fájl került hozzáadásra.`,
      color: "warning",
    });
  }

  const optimizedFiles = await Promise.all(
    acceptedFiles.map((file) => resizeImageFile(file))
  );
  const startIndex = selectedPostImages.value.length;
  selectedPostImages.value = [...selectedPostImages.value, ...optimizedFiles];
  optimizedFiles.forEach((_, idx) => {
    getImageInsertOption(startIndex + idx);
  });
  refreshImagePreviews();
  input.value = "";
}

function removeSelectedImage(index: number) {
  selectedPostImages.value.splice(index, 1);

  if (selectedCoverImageIndex.value === index) {
    selectedCoverImageIndex.value = null;
  } else if (
    selectedCoverImageIndex.value !== null &&
    selectedCoverImageIndex.value > index
  ) {
    selectedCoverImageIndex.value -= 1;
  }

  refreshImagePreviews();
}

// ----------------- categories update: új elemet adunk az availableCategories-hez ha kell ----------
function onCategoriesUpdate(newVal: string[]) {
  // minden kategória, ami nincs az availableCategories-ben, hozzáadjuk
  newVal.forEach((c) => {
    const normalized = c.trim();
    if (!normalized) return;
    if (!availableCategories.value.includes(normalized)) {
      availableCategories.value.push(normalized);
    }
  });
  newPost.value.categories = newVal.map((c) => c.trim()).filter(Boolean);
}

async function loadBlogCategories() {
  try {
    const res = await api.get("/blog/categories/");
    const items = res?.data?.responseData?.items;
    if (!Array.isArray(items)) return;

    blogCategories.value = items
      .map((item: any) => ({
        id: Number(item?.id || 0),
        name: String(item?.name || "").trim(),
      }))
      .filter(
        (item: any) => Number.isFinite(item.id) && item.id > 0 && item.name
      );

    const names = blogCategories.value.map((item) => item.name).filter(Boolean);

    availableCategories.value = Array.from(
      new Set([...availableCategories.value, ...names])
    );
  } catch (error) {
    console.warn("Kategóriák betöltése sikertelen:", error);
  }
}

// ----------------- create / save / cancel -----------------
async function createPost(targetStatus: "draft" | "published" = "published") {
  const hasTitle = Boolean(newPost.value.title?.trim());
  const hasContent = Boolean(newPost.value.content?.trim());
  if (!hasTitle || !hasContent) {
    store.dispatch("setAlert", {
      error: "A bejegyzés címe és tartalma is kötelező!",
    });
    return;
  }

  isBlogPostSubmitting.value = true;
  blogUploadProgress.value = 0;
  try {
    const serializedContent = serializeEditorContentForBackend();
    const payload = new FormData();
    payload.append("title", newPost.value.title);
    payload.append("content", serializedContent);
    payload.append("status", targetStatus);
    payload.append("categories", JSON.stringify(newPost.value.categories));
    if (newPost.value.imageUrl) {
      payload.append("cover_image", newPost.value.imageUrl);
    }
    if (selectedCoverImageIndex.value !== null) {
      payload.append("coverImageIndex", String(selectedCoverImageIndex.value));
    }
    selectedPostImages.value.forEach((file) => {
      payload.append("images", file);
    });

    const response = await api.post("/blog/post/", payload, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (event: any) => {
        const total = Number(event?.total || 0);
        const loaded = Number(event?.loaded || 0);
        if (total > 0) {
          blogUploadProgress.value = Math.min(
            100,
            Math.max(1, Math.round((loaded / total) * 100))
          );
        } else {
          blogUploadProgress.value = 0;
        }
      },
    });

    const responseData = response.data;
    const createdPost = responseData?.responseData?.item;
    if (createdPost) {
      store.commit("ADD_POST", createdPost);
    }

    // Sikeres backend válasz (201 status) után:
    store.dispatch("setSnackbar", {
      // A backend válaszában lévő üzeneteket használhatjuk:
      title:
        responseData.responseData.messageTitle ||
        (targetStatus === "draft"
          ? "Piszkozat mentve"
          : "Blogbejegyzés létrehozva"),
      text:
        responseData.responseData.responseMessage ||
        (targetStatus === "draft"
          ? "A piszkozat mentése sikeres."
          : "A bejegyzés sikeresen elküldve."),
      color: "success",
    });

    // Űrlap visszaállítása és dialog bezárása
    resetPostForm();
    showPostDialog.value = false;

    if (targetStatus === "draft" && createdPost?.id) {
      await router.push(`/blog/${createdPost.id}/edit`);
      return;
    }
    await router.push({ name: "forum-page" });
    window.location.reload();
  } catch (err: any) {
    // 3. Hiba kezelése (pl. 4xx vagy 5xx status kód a backendről)

    // Megpróbáljuk beolvasni a backend által küldött hibaüzenetet,
    // ha a hiba struktúra ezt lehetővé teszi (pl. err.response.data.responseData.responseMessage)
    const backendMessage = err.response?.data?.responseData?.responseMessage;

    store.dispatch("setSnackbar", {
      title: "Hiba a bejegyzés létrehozásakor",
      text: backendMessage || err.message || "Ismeretlen hiba történt.",
      color: "error",
    });
  } finally {
    isBlogPostSubmitting.value = false;
    blogUploadProgress.value = 0;
  }
}

function onCancel() {
  resetPostForm();
  showPostDialog.value = false;
}

async function deleteBlogCategory(category: { id: number; name: string }) {
  if (!category?.id || isCategoryDeleting.value) return;
  isCategoryDeleting.value = true;
  try {
    await api.delete(`/blog/categories/${category.id}`);
    blogCategories.value = blogCategories.value.filter(
      (row) => row.id !== category.id
    );
    availableCategories.value = availableCategories.value.filter(
      (name) => name !== category.name
    );
    newPost.value.categories = newPost.value.categories.filter(
      (name) => name !== category.name
    );
    store.dispatch("setSnackbar", {
      title: "Rendszer üzenet",
      text: "Kategória véglegesen törölve.",
      color: "success",
    });
  } catch (error: any) {
    store.dispatch("setSnackbar", {
      title: "Hiba",
      text:
        error?.response?.data?.responseData?.responseMessage ||
        "A kategória törlése sikertelen.",
      color: "error",
    });
  } finally {
    isCategoryDeleting.value = false;
  }
}

function resetPostForm() {
  newPost.value = {
    title: "",
    content: "",
    imageUrl: "",
    categories: [],
  };
  imagePreviews.value.forEach((url) => URL.revokeObjectURL(url));
  imagePreviews.value = [];
  selectedPostImages.value = [];
  selectedCoverImageIndex.value = null;
  imageInsertOptions.value = {};
  if (postContentEditor.value) {
    postContentEditor.value.innerHTML = "";
  }
}

async function refreshStatisticsAccess() {
  if (!profile.value?.id) {
    canViewStatistics.value = false;
    return;
  }

  try {
    const response = await api.get("/profile/statistics-access");
    canViewStatistics.value = Boolean(response?.data?.responseData?.canView);
  } catch {
    canViewStatistics.value = false;
  }
}

// Lifecycle
onMounted(() => {
  const savedTheme = localStorage.getItem("currentTheme");
  if (savedTheme) {
    theme.global.name.value = savedTheme;
  }
  themeIcon.value =
    theme.global.name.value === "dark"
      ? "mdi-weather-sunny"
      : "mdi-weather-night";

  loadBlogCategories();
  refreshStatisticsAccess();
  document.addEventListener("selectionchange", onEditorSelectionChange);
});

onBeforeUnmount(() => {
  document.removeEventListener("selectionchange", onEditorSelectionChange);
});

watch(showPostDialog, (visible) => {
  if (!visible) return;
  nextTick(() => {
    if (postContentEditor.value) {
      postContentEditor.value.innerHTML = newPost.value.content || "";
      refreshEditorToolbarState(
        postContentEditor.value,
        postEditorToolbarState
      );
    }
  });
});

watch(showGameDialog, (visible) => {
  if (!visible) return;
  nextTick(() => {
    if (gameDescriptionEditor.value) {
      gameDescriptionEditor.value.innerHTML = newGame.value.description || "";
      refreshEditorToolbarState(
        gameDescriptionEditor.value,
        gameEditorToolbarState
      );
    }
  });
});

watch(showMapDialog, (visible) => {
  if (visible) {
    nextTick(() => {
      if (mapDescriptionEditor.value) {
        mapDescriptionEditor.value.innerHTML = newMap.value.description || "";
        refreshEditorToolbarState(
          mapDescriptionEditor.value,
          mapEditorToolbarState
        );
      }
    });
    return;
  }

  if (!visible && !isMapSubmitting.value) {
    resetMapForm();
  }
});

watch(
  () => profile.value?.id,
  () => {
    refreshStatisticsAccess();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppSnackbar = _resolveComponent("AppSnackbar")!
  const _component_AppConfirmDialog = _resolveComponent("AppConfirmDialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        flat: "",
        height: "72",
        color: "surface",
        elevation: 1,
        class: "px-4 main-app-bar"
      }, {
        append: _withCtx(() => [
          (profile.value?.username)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                class: "mr-2 d-none d-md-inline-flex desktop-user-chip",
                color: "primary",
                variant: "tonal"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    start: "",
                    size: "16"
                  }, {
                    default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                      _createTextVNode("mdi-shield-account-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(profile.value.username), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!profile.value?.username)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                to: { name: 'login-page' },
                variant: "outlined",
                color: "primary",
                class: "mr-2 d-none d-md-inline-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { left: "" }, {
                    default: _withCtx(() => [...(_cache[112] || (_cache[112] = [
                      _createTextVNode("mdi-login", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[113] || (_cache[113] = _createTextVNode(" Bejelentkezés ", -1))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (profile.value?.username)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 2,
                icon: "",
                variant: "text",
                onClick: logoutUser
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                      _createTextVNode("mdi-logout", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (profile.value?.username)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 3,
                icon: "",
                variant: "text",
                onClick: goToProfile,
                class: _normalizeClass({ 'profile-active': isProfileActive.value })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                      _createTextVNode("mdi-account", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            onClick: toggleTheme
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(themeIcon.value), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            class: "d-md-none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value))
          }),
          _createVNode(_component_v_app_bar_title, { class: "font-weight-bold text-h6 d-none d-md-block" }, {
            default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
              _createTextVNode(" Vicces Sárga Kutyák ", -1)
            ]))]),
            _: 1
          }),
          _cache[116] || (_cache[116] = _createElementVNode("div", { class: "mobile-brand d-md-none" }, [
            _createElementVNode("div", { class: "mobile-brand-title" }, "VSK"),
            _createElementVNode("div", { class: "mobile-brand-subtitle" }, "Közösségi platform")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeTab).value = $event)),
              class: "desktop-tabs",
              "bg-color": "transparent",
              "align-with-title": "",
              onClick: resetProfileActive
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_menu, { "offset-y": "" }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_tab, _normalizeProps(_guardReactiveProps(props)), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          start: "",
                          size: "16"
                        }, {
                          default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                            _createTextVNode("mdi-post-outline", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[89] || (_cache[89] = _createTextVNode("Blog ", -1))
                      ]),
                      _: 1
                    }, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      density: "compact",
                      class: "modern-menu-list"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, {
                          to: { name: 'forum-page' },
                          "prepend-icon": "mdi-view-dashboard-outline"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                                _createTextVNode("Blog főoldal", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (profile.value?.Permission?.power >= 100)
                          ? (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 0,
                              "prepend-icon": "mdi-plus-circle-outline",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (showPostDialog.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                    _createTextVNode("Új bejegyzés", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (profile.value?.username)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (profile.value?.Permission?.power >= 100)
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 0,
                            to: { name: 'users-page' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                size: "16"
                              }, {
                                default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                                  _createTextVNode("mdi-account-multiple-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[93] || (_cache[93] = _createTextVNode("Felhasználók ", -1))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (profile.value?.Permission?.power >= 500)
                        ? (_openBlock(), _createBlock(_component_v_menu, {
                            key: 1,
                            "offset-y": ""
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_tab, _normalizeProps(_guardReactiveProps(props)), {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    size: "16"
                                  }, {
                                    default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                                      _createTextVNode("mdi-tools", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _cache[95] || (_cache[95] = _createTextVNode("Fejlesztői ", -1))
                                ]),
                                _: 1
                              }, 16)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                density: "compact",
                                class: "modern-menu-list"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'developer-tools-page' },
                                    "prepend-icon": "mdi-cog-outline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                                          _createTextVNode("Eszközök", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'developer-errors-page' },
                                    "prepend-icon": "mdi-alert-circle-outline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                                          _createTextVNode("Hibák", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'developer-emails-page' },
                                    "prepend-icon": "mdi-email-outline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                                          _createTextVNode("Levelek", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'developer-audit-page' },
                                    "prepend-icon": "mdi-history"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                                          _createTextVNode("Audit", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item, {
                                    to: { name: 'developer-statistics-settings-page' },
                                    "prepend-icon": "mdi-chart-box-outline"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                                          _createTextVNode("Statisztika beállítás", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_tab, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                size: "16"
                              }, {
                                default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                                  _createTextVNode("mdi-gamepad-variant-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[102] || (_cache[102] = _createTextVNode("Játékok ", -1))
                            ]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            density: "compact",
                            class: "modern-menu-list"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                to: { name: 'games-page' },
                                "prepend-icon": "mdi-view-dashboard-outline"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                                      _createTextVNode("Játékok főoldal", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (profile.value?.Permission?.power >= 100)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    "prepend-icon": "mdi-plus-circle-outline",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (openGameDialog()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                                          _createTextVNode("Új játék", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (canViewStatistics.value)
                        ? (_openBlock(), _createBlock(_component_v_tab, {
                            key: 2,
                            to: { name: 'statistics-page' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                size: "16"
                              }, {
                                default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                                  _createTextVNode("mdi-chart-line", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[106] || (_cache[106] = _createTextVNode("Statisztikák ", -1))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_tab, _normalizeProps(_guardReactiveProps(props)), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                start: "",
                                size: "16"
                              }, {
                                default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                                  _createTextVNode("mdi-map-marker-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[108] || (_cache[108] = _createTextVNode("Pályák ", -1))
                            ]),
                            _: 1
                          }, 16)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, {
                            density: "compact",
                            class: "modern-menu-list"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item, {
                                to: { name: 'maps-page' },
                                "prepend-icon": "mdi-view-dashboard-outline"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [...(_cache[109] || (_cache[109] = [
                                      _createTextVNode("Pályák főoldal", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (profile.value?.Permission?.power >= 100)
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    "prepend-icon": "mdi-plus-circle-outline",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showMapDialog.value = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [...(_cache[110] || (_cache[110] = [
                                          _createTextVNode("Új pálya", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((drawer).value = $event)),
        temporary: "",
        location: "left",
        class: "d-md-none mobile-drawer",
        color: "surface"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[117] || (_cache[117] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "mobile-drawer-overline mb-1" }, "Navigáció"),
              _createElementVNode("h3", { class: "mobile-drawer-title mb-0" }, "Vicces Sárga Kutyák")
            ], -1)),
            (profile.value?.Permission?.name)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  size: "small",
                  color: "primary",
                  variant: "flat"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(profile.value.Permission.name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_divider, { class: "mb-3" }),
          (profile.value?.username)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  block: "",
                  variant: "tonal",
                  color: "primary",
                  "prepend-icon": "mdi-post-outline",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {
            showPostDialog.value = true;
            drawer.value = false;
          })
                }, {
                  default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
                    _createTextVNode(" Új blogbejegyzés ", -1)
                  ]))]),
                  _: 1
                }),
                (profile.value?.Permission?.power >= 100)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      block: "",
                      variant: "tonal",
                      color: "success",
                      "prepend-icon": "mdi-gamepad-variant-outline",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (openGameDialog(true)))
                    }, {
                      default: _withCtx(() => [...(_cache[119] || (_cache[119] = [
                        _createTextVNode(" Új játék ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (profile.value?.Permission?.power >= 100)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      block: "",
                      variant: "tonal",
                      color: "info",
                      "prepend-icon": "mdi-map-marker-plus-outline",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {
            showMapDialog.value = true;
            drawer.value = false;
          })
                    }, {
                      default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                        _createTextVNode(" Új pálya ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_list, {
            nav: "",
            density: "comfortable",
            class: "mobile-nav-list"
          }, {
            default: _withCtx(() => [
              (!profile.value?.username)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_list_item, {
                      to: { name: 'forum-page' },
                      "prepend-icon": "mdi-post-outline",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                            _createTextVNode("Blog", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, {
                      to: { name: 'login-page' },
                      "prepend-icon": "mdi-login",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                            _createTextVNode("Bejelentkezés", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_list_item, {
                      to: { name: 'forum-page' },
                      "prepend-icon": "mdi-post-outline",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                            _createTextVNode("Blog", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, {
                      to: { name: 'games-page' },
                      "prepend-icon": "mdi-gamepad-variant-outline",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[124] || (_cache[124] = [
                            _createTextVNode("Játékok", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item, {
                      to: { name: 'maps-page' },
                      "prepend-icon": "mdi-map-marker-outline",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[125] || (_cache[125] = [
                            _createTextVNode("Pályák", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (canViewStatistics.value)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          to: { name: 'statistics-page' },
                          "prepend-icon": "mdi-chart-line",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (drawer.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                _createTextVNode("Statisztikák", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_list_item, {
                      to: { name: 'profile-page' },
                      "prepend-icon": "mdi-account-circle-outline",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (drawer.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                            _createTextVNode("Profil", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (profile.value?.Permission?.power >= 100)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          to: { name: 'users-page' },
                          "prepend-icon": "mdi-account-multiple-outline",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (drawer.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                                _createTextVNode("Felhasználók", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_expansion_panels, {
                      flat: "",
                      class: "mobile-expansions"
                    }, {
                      default: _withCtx(() => [
                        (profile.value?.Permission?.power >= 500)
                          ? (_openBlock(), _createBlock(_component_v_expansion_panel, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_expansion_panel_title, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "mr-2",
                                      size: "18"
                                    }, {
                                      default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                                        _createTextVNode("mdi-tools", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _cache[130] || (_cache[130] = _createTextVNode(" Fejlesztői ", -1))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_expansion_panel_text, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      to: { name: 'developer-tools-page' },
                                      "prepend-icon": "mdi-cog-outline",
                                      onClick: _cache[16] || (_cache[16] = ($event: any) => (drawer.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [...(_cache[131] || (_cache[131] = [
                                            _createTextVNode("Eszközök", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, {
                                      to: { name: 'developer-errors-page' },
                                      "prepend-icon": "mdi-alert-circle-outline",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (drawer.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [...(_cache[132] || (_cache[132] = [
                                            _createTextVNode("Hibák", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, {
                                      to: { name: 'developer-emails-page' },
                                      "prepend-icon": "mdi-email-outline",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (drawer.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [...(_cache[133] || (_cache[133] = [
                                            _createTextVNode("Levelek", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, {
                                      to: { name: 'developer-audit-page' },
                                      "prepend-icon": "mdi-history",
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (drawer.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [...(_cache[134] || (_cache[134] = [
                                            _createTextVNode("Audit", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_list_item, {
                                      to: { name: 'developer-statistics-settings-page' },
                                      "prepend-icon": "mdi-chart-box-outline",
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (drawer.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [...(_cache[135] || (_cache[135] = [
                                            _createTextVNode("Statisztika beállítás", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_main, { class: "app-main" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "app-content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_dialog, {
                modelValue: showGameDialog.value,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((showGameDialog).value = $event)),
                "max-width": "600px",
                persistent: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "elevation-10 rounded-lg" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { left: "" }, {
                            default: _withCtx(() => [...(_cache[136] || (_cache[136] = [
                              _createTextVNode("mdi-gamepad", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[137] || (_cache[137] = _createTextVNode(" Új játék létrehozása ", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, { ref: "form" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_divider, { class: "my-4" }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: newGame.value.name,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((newGame.value.name) = $event)),
                                        label: "Játék neve",
                                        "prepend-inner-icon": "mdi-gamepad-variant",
                                        outlined: "",
                                        dense: "",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", _hoisted_5, [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            gameEditorToolbarState.value.bold ? 'flat' : 'text'
                          ,
                                            color: gameEditorToolbarState.value.bold ? 'primary' : '',
                                            icon: "mdi-format-bold",
                                            onClick: _cache[23] || (_cache[23] = ($event: any) => (applyGameEditorCommand('bold')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            gameEditorToolbarState.value.italic ? 'flat' : 'text'
                          ,
                                            color: 
                            gameEditorToolbarState.value.italic ? 'primary' : ''
                          ,
                                            icon: "mdi-format-italic",
                                            onClick: _cache[24] || (_cache[24] = ($event: any) => (applyGameEditorCommand('italic')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            gameEditorToolbarState.value.underline ? 'flat' : 'text'
                          ,
                                            color: 
                            gameEditorToolbarState.value.underline ? 'primary' : ''
                          ,
                                            icon: "mdi-format-underline",
                                            onClick: _cache[25] || (_cache[25] = ($event: any) => (applyGameEditorCommand('underline')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            gameEditorToolbarState.value.unorderedList
                              ? 'flat'
                              : 'text'
                          ,
                                            color: 
                            gameEditorToolbarState.value.unorderedList
                              ? 'primary'
                              : ''
                          ,
                                            icon: "mdi-format-list-bulleted",
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (applyGameEditorCommand('insertUnorderedList')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            gameEditorToolbarState.value.orderedList ? 'flat' : 'text'
                          ,
                                            color: 
                            gameEditorToolbarState.value.orderedList ? 'primary' : ''
                          ,
                                            icon: "mdi-format-list-numbered",
                                            onClick: _cache[27] || (_cache[27] = ($event: any) => (applyGameEditorCommand('insertOrderedList')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: gameEditorToolbarState.value.h2 ? 'flat' : 'text',
                                            color: gameEditorToolbarState.value.h2 ? 'primary' : '',
                                            onClick: _cache[28] || (_cache[28] = ($event: any) => (applyGameEditorCommand('formatBlock', 'h2')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[138] || (_cache[138] = [
                                              _createTextVNode(" H2 ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: gameEditorToolbarState.value.h3 ? 'flat' : 'text',
                                            color: gameEditorToolbarState.value.h3 ? 'primary' : '',
                                            onClick: _cache[29] || (_cache[29] = ($event: any) => (applyGameEditorCommand('formatBlock', 'h3')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[139] || (_cache[139] = [
                                              _createTextVNode(" H3 ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["variant", "color"])
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                          _createElementVNode("div", {
                                            ref_key: "gameDescriptionEditor",
                                            ref: gameDescriptionEditor,
                                            class: "editor-contenteditable",
                                            contenteditable: "true",
                                            onInput: onGameDescriptionInput
                                          }, null, 544)
                                        ])
                                      ]),
                                      _createVNode(_component_v_expansion_panels, {
                                        class: "mt-2",
                                        variant: "accordion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_title, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    start: "",
                                                    class: "mr-2"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[140] || (_cache[140] = [
                                                      _createTextVNode("mdi-book-open-page-variant", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[141] || (_cache[141] = _createTextVNode(" Formázási segédlet ", -1))
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [...(_cache[142] || (_cache[142] = [
                                                  _createElementVNode("ul", { class: "pl-4 text-caption" }, [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<br>"),
                                                      _createTextVNode(" - Sortörés")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<b>Szöveg</b>"),
                                                      _createTextVNode(" - Félkövér ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<i>Szöveg</i>"),
                                                      _createTextVNode(" - Dőlt ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<u>Szöveg</u>"),
                                                      _createTextVNode(" - Aláhúzott ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<a href=\"url\">Link</a>"),
                                                      _createTextVNode(" - Hivatkozás ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<ul><li>Elem</li></ul>"),
                                                      _createTextVNode(" - Lista ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<ol><li>Elem</li></ol>"),
                                                      _createTextVNode(" - Számozott lista ")
                                                    ])
                                                  ], -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        label: "Játék időpontja",
                                        modelValue: formattedGameDate.value,
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((formattedGameDate).value = $event)),
                                        "prepend-inner-icon": "mdi-calendar-clock",
                                        outlined: "",
                                        dense: "",
                                        readonly: "",
                                        onFocus: _cache[31] || (_cache[31] = ($event: any) => (menuGameDatePicker.value = true))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_menu, {
                                        modelValue: menuGameDatePicker.value,
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((menuGameDatePicker).value = $event)),
                                        "close-on-content-click": false,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "nudge-width": 200
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_date_picker, {
                                                    modelValue: tempGameDate.value,
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((tempGameDate).value = $event)),
                                                    min: _unref(today)
                                                  }, null, 8, ["modelValue", "min"]),
                                                  _createVNode(_component_v_row, {
                                                    dense: "",
                                                    class: "mt-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field, {
                                                            modelValue: tempGameTime.value,
                                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((tempGameTime).value = $event)),
                                                            label: "Óra:Perc",
                                                            type: "time",
                                                            outlined: "",
                                                            dense: "",
                                                            required: ""
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_spacer),
                                                  _createVNode(_component_v_btn, {
                                                    onClick: _cache[34] || (_cache[34] = ($event: any) => (menuGameDatePicker.value = false))
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[143] || (_cache[143] = [
                                                      _createTextVNode("Bezárás", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_btn, {
                                                    color: "primary",
                                                    onClick: saveGameDateTime
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                                                      _createTextVNode("Mentés", -1)
                                                    ]))]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_divider, { class: "my-4" }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: newGame.value.mapId,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((newGame.value.mapId) = $event)),
                                        items: maps.value,
                                        "item-title": "name",
                                        "item-value": "id",
                                        label: "Válassz pályát",
                                        outlined: "",
                                        dense: "",
                                        required: ""
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select, {
                                        modelValue: newGame.value.allowedGroupIds,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((newGame.value.allowedGroupIds) = $event)),
                                        items: availableEventGroups.value,
                                        "item-title": "name",
                                        "item-value": "id",
                                        label: "Engedélyezett csapatok",
                                        "prepend-inner-icon": "mdi-account-multiple-check",
                                        multiple: "",
                                        chips: "",
                                        "closable-chips": "",
                                        clearable: "",
                                        outlined: "",
                                        dense: "",
                                        hint: "Ha üresen hagyod, minden csapat láthatja a játékot.",
                                        "persistent-hint": ""
                                      }, null, 8, ["modelValue", "items"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_divider, { class: "my-4" }),
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        label: "Jelentkezési határidő",
                                        modelValue: formattedEndOfApplyDate.value,
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((formattedEndOfApplyDate).value = $event)),
                                        "prepend-inner-icon": "mdi-calendar-clock",
                                        outlined: "",
                                        dense: "",
                                        readonly: "",
                                        onFocus: _cache[39] || (_cache[39] = ($event: any) => (menuEndOfApplyPicker.value = true))
                                      }, null, 8, ["modelValue"]),
                                      _createVNode(_component_v_menu, {
                                        modelValue: menuEndOfApplyPicker.value,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((menuEndOfApplyPicker).value = $event)),
                                        "close-on-content-click": false,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "nudge-width": 200
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), null, 16)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_card_text, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_date_picker, {
                                                    modelValue: tempEndOfApplyDate.value,
                                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((tempEndOfApplyDate).value = $event)),
                                                    min: _unref(today),
                                                    max: formattedGameDate.value
                                                  }, null, 8, ["modelValue", "min", "max"]),
                                                  _createVNode(_component_v_row, {
                                                    dense: "",
                                                    class: "mt-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_text_field, {
                                                            modelValue: tempEndOfApplyTime.value,
                                                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((tempEndOfApplyTime).value = $event)),
                                                            label: "Óra:Perc",
                                                            type: "time",
                                                            outlined: "",
                                                            dense: "",
                                                            required: ""
                                                          }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_card_actions, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_spacer),
                                                  _createVNode(_component_v_btn, {
                                                    onClick: _cache[42] || (_cache[42] = ($event: any) => (menuEndOfApplyPicker.value = false)),
                                                    text: ""
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                                                      _createTextVNode("Bezárás", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_btn, {
                                                    onClick: saveEndOfApplyDate,
                                                    color: "primary"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[146] || (_cache[146] = [
                                                      _createTextVNode("Mentés", -1)
                                                    ]))]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        label: "Maximális résztvevők",
                                        modelValue: newGame.value.maxParticipants,
                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((newGame.value.maxParticipants) = $event)),
                                        type: "number",
                                        outlined: "",
                                        dense: "",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: newGame.value.sendNotificationEmails,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((newGame.value.sendNotificationEmails) = $event)),
                                        label: "Értesítő e-mailek küldése",
                                        dense: "",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            text: "",
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (showGameDialog.value = false))
                          }, {
                            default: _withCtx(() => [...(_cache[147] || (_cache[147] = [
                              _createTextVNode("Mégse", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            onClick: createGame
                          }, {
                            default: _withCtx(() => [...(_cache[148] || (_cache[148] = [
                              _createTextVNode("Létrehozás", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: showMapDialog.value,
                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((showMapDialog).value = $event)),
                "max-width": "900px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "pa-6",
                    elevation: "10",
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold mb-4" }, {
                        default: _withCtx(() => [...(_cache[149] || (_cache[149] = [
                          _createTextVNode(" Új pálya létrehozása ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_form, { ref: "form" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: newMap.value.name,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((newMap.value.name) = $event)),
                                        label: "Pálya neve",
                                        "prepend-inner-icon": "mdi-map-marker",
                                        outlined: "",
                                        dense: "",
                                        required: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: newMap.value.address,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((newMap.value.address) = $event)),
                                        label: "Cím",
                                        "prepend-inner-icon": "mdi-map",
                                        outlined: "",
                                        dense: ""
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            mapEditorToolbarState.value.bold ? 'flat' : 'text'
                          ,
                                            color: mapEditorToolbarState.value.bold ? 'primary' : '',
                                            icon: "mdi-format-bold",
                                            onClick: _cache[50] || (_cache[50] = ($event: any) => (applyMapEditorCommand('bold')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            mapEditorToolbarState.value.italic ? 'flat' : 'text'
                          ,
                                            color: mapEditorToolbarState.value.italic ? 'primary' : '',
                                            icon: "mdi-format-italic",
                                            onClick: _cache[51] || (_cache[51] = ($event: any) => (applyMapEditorCommand('italic')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            mapEditorToolbarState.value.underline ? 'flat' : 'text'
                          ,
                                            color: 
                            mapEditorToolbarState.value.underline ? 'primary' : ''
                          ,
                                            icon: "mdi-format-underline",
                                            onClick: _cache[52] || (_cache[52] = ($event: any) => (applyMapEditorCommand('underline')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            mapEditorToolbarState.value.unorderedList
                              ? 'flat'
                              : 'text'
                          ,
                                            color: 
                            mapEditorToolbarState.value.unorderedList ? 'primary' : ''
                          ,
                                            icon: "mdi-format-list-bulleted",
                                            onClick: _cache[53] || (_cache[53] = ($event: any) => (applyMapEditorCommand('insertUnorderedList')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: 
                            mapEditorToolbarState.value.orderedList ? 'flat' : 'text'
                          ,
                                            color: 
                            mapEditorToolbarState.value.orderedList ? 'primary' : ''
                          ,
                                            icon: "mdi-format-list-numbered",
                                            onClick: _cache[54] || (_cache[54] = ($event: any) => (applyMapEditorCommand('insertOrderedList')))
                                          }, null, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: mapEditorToolbarState.value.h2 ? 'flat' : 'text',
                                            color: mapEditorToolbarState.value.h2 ? 'primary' : '',
                                            onClick: _cache[55] || (_cache[55] = ($event: any) => (applyMapEditorCommand('formatBlock', 'h2')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[150] || (_cache[150] = [
                                              _createTextVNode(" H2 ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["variant", "color"]),
                                          _createVNode(_component_v_btn, {
                                            size: "small",
                                            variant: mapEditorToolbarState.value.h3 ? 'flat' : 'text',
                                            color: mapEditorToolbarState.value.h3 ? 'primary' : '',
                                            onClick: _cache[56] || (_cache[56] = ($event: any) => (applyMapEditorCommand('formatBlock', 'h3')))
                                          }, {
                                            default: _withCtx(() => [...(_cache[151] || (_cache[151] = [
                                              _createTextVNode(" H3 ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["variant", "color"])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                          _createElementVNode("div", {
                                            ref_key: "mapDescriptionEditor",
                                            ref: mapDescriptionEditor,
                                            class: "editor-contenteditable",
                                            contenteditable: "true",
                                            onInput: onMapDescriptionInput
                                          }, null, 544)
                                        ])
                                      ]),
                                      _createVNode(_component_v_expansion_panels, {
                                        class: "mt-4",
                                        variant: "accordion"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_expansion_panel, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_expansion_panel_title, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, {
                                                    start: "",
                                                    class: "mr-2"
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[152] || (_cache[152] = [
                                                      _createTextVNode("mdi-book-open-page-variant", -1)
                                                    ]))]),
                                                    _: 1
                                                  }),
                                                  _cache[153] || (_cache[153] = _createTextVNode(" Formázási segédlet ", -1))
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_expansion_panel_text, null, {
                                                default: _withCtx(() => [...(_cache[154] || (_cache[154] = [
                                                  _createElementVNode("ul", { class: "pl-4 text-caption" }, [
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<br>"),
                                                      _createTextVNode(" - Sortörés")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<b>Szöveg</b>"),
                                                      _createTextVNode(" - Félkövér ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<i>Szöveg</i>"),
                                                      _createTextVNode(" - Dőlt ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<u>Szöveg</u>"),
                                                      _createTextVNode(" - Aláhúzott ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<a href=\"url\">Link</a>"),
                                                      _createTextVNode(" - Hivatkozás ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<ul><li>Elem</li></ul>"),
                                                      _createTextVNode(" - Lista ")
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                      _createElementVNode("code", null, "<ol><li>Elem</li></ol>"),
                                                      _createTextVNode(" - Számozott lista ")
                                                    ])
                                                  ], -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: newMap.value.imageUrl,
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((newMap.value.imageUrl) = $event)),
                                        label: "Pálya képe URL (opcionális)",
                                        "prepend-inner-icon": "mdi-image",
                                        outlined: "",
                                        dense: "",
                                        disabled: selectedMapImage.value !== null
                                      }, null, 8, ["modelValue", "disabled"]),
                                      _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_component_v_btn, {
                                          variant: "outlined",
                                          "prepend-icon": "mdi-upload",
                                          disabled: isMapSubmitting.value,
                                          onClick: _cache[58] || (_cache[58] = ($event: any) => (mapImageInput.value?.click()))
                                        }, {
                                          default: _withCtx(() => [...(_cache[155] || (_cache[155] = [
                                            _createTextVNode(" Pályakép feltöltése ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(selectedMapImage.value
                            ? selectedMapImage.value.name
                            : "Nincs fájl kiválasztva"), 1),
                                        (selectedMapImage.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              size: "small",
                                              variant: "text",
                                              color: "error",
                                              onClick: removeSelectedMapImage
                                            }, {
                                              default: _withCtx(() => [...(_cache[156] || (_cache[156] = [
                                                _createTextVNode(" Törlés ", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (isMapSubmitting.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createVNode(_component_v_progress_linear, {
                                              "model-value": mapUploadProgress.value,
                                              indeterminate: mapUploadProgress.value <= 0,
                                              color: "primary"
                                            }, null, 8, ["model-value", "indeterminate"]),
                                            _createElementVNode("div", _hoisted_13, " Feltöltés folyamatban... " + _toDisplayString(mapUploadProgress.value > 0 ? `${mapUploadProgress.value}%` : ""), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (mapImagePreview.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createElementVNode("img", {
                                              src: mapImagePreview.value,
                                              alt: "Pályakép előnézet",
                                              class: "map-image-preview"
                                            }, null, 8, _hoisted_15)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("input", {
                                        ref_key: "mapImageInput",
                                        ref: mapImageInput,
                                        type: "file",
                                        accept: "image/*",
                                        style: {"display":"none"},
                                        onChange: onMapImageSelect
                                      }, null, 544),
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_v_btn, {
                                          variant: "outlined",
                                          "prepend-icon": "mdi-upload",
                                          disabled: isMapSubmitting.value,
                                          onClick: _cache[59] || (_cache[59] = ($event: any) => (mapImageInput.value?.click()))
                                        }, {
                                          default: _withCtx(() => [...(_cache[157] || (_cache[157] = [
                                            _createTextVNode(" Pályakép feltöltése ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(selectedMapImage.value
                            ? selectedMapImage.value.name
                            : "Nincs fájl kiválasztva"), 1),
                                        (selectedMapImage.value)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              size: "small",
                                              variant: "text",
                                              color: "error",
                                              onClick: removeSelectedMapImage
                                            }, {
                                              default: _withCtx(() => [...(_cache[158] || (_cache[158] = [
                                                _createTextVNode(" Törlés ", -1)
                                              ]))]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      (isMapSubmitting.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createVNode(_component_v_progress_linear, {
                                              "model-value": mapUploadProgress.value,
                                              indeterminate: mapUploadProgress.value <= 0,
                                              color: "primary"
                                            }, null, 8, ["model-value", "indeterminate"]),
                                            _createElementVNode("div", _hoisted_19, " Feltöltés folyamatban... " + _toDisplayString(mapUploadProgress.value > 0 ? `${mapUploadProgress.value}%` : ""), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (mapImagePreview.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("img", {
                                              src: mapImagePreview.value,
                                              alt: "Pályakép előnézet",
                                              class: "map-image-preview"
                                            }, null, 8, _hoisted_21)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, { class: "my-4" }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            color: "grey",
                            onClick: _cache[60] || (_cache[60] = ($event: any) => (showMapDialog.value = false))
                          }, {
                            default: _withCtx(() => [...(_cache[159] || (_cache[159] = [
                              _createTextVNode(" Mégse ", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "flat",
                            loading: isMapSubmitting.value,
                            disabled: isMapSubmitting.value,
                            onClick: createMap
                          }, {
                            default: _withCtx(() => [...(_cache[160] || (_cache[160] = [
                              _createTextVNode(" Létrehozás ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["loading", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: showPostDialog.value,
                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((showPostDialog).value = $event)),
                "max-width": "900px",
                persistent: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { class: "elevation-10 rounded-lg" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold bg-primary pa-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { left: "" }, {
                            default: _withCtx(() => [...(_cache[161] || (_cache[161] = [
                              _createTextVNode("mdi-post-outline", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[162] || (_cache[162] = _createTextVNode(" Új Blogbejegyzés Létrehozása ", -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, { class: "pt-4" }, {
                        default: _withCtx(() => [
                          (isBlogPostSubmitting.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createVNode(_component_v_alert, {
                                  type: "info",
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(selectedPostImages.value.length > 0
                      ? "Képek feltöltése és bejegyzés mentése folyamatban..."
                      : "Bejegyzés mentése folyamatban..."), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_progress_linear, {
                                  "model-value": blogUploadProgress.value,
                                  indeterminate: blogUploadProgress.value <= 0,
                                  color: "primary"
                                }, null, 8, ["model-value", "indeterminate"]),
                                (blogUploadProgress.value > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Feltöltési állapot: " + _toDisplayString(blogUploadProgress.value) + "% ", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_form, { ref: "postForm" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_text_field, {
                                modelValue: newPost.value.title,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((newPost.value.title) = $event)),
                                label: "Bejegyzés címe",
                                "prepend-inner-icon": "mdi-format-title",
                                variant: "outlined",
                                required: "",
                                class: "mb-4"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_v_expansion_panels, {
                                  class: "mt-4",
                                  variant: "accordion"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_expansion_panel, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_expansion_panel_title, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              start: "",
                                              class: "mr-2"
                                            }, {
                                              default: _withCtx(() => [...(_cache[163] || (_cache[163] = [
                                                _createTextVNode("mdi-book-open-page-variant", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _cache[164] || (_cache[164] = _createTextVNode(" Formázási segédlet ", -1))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_expansion_panel_text, null, {
                                          default: _withCtx(() => [...(_cache[165] || (_cache[165] = [
                                            _createElementVNode("ul", { class: "pl-4 text-caption" }, [
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<br>"),
                                                _createTextVNode(" - Sortörés")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<b>Szöveg</b>"),
                                                _createTextVNode(" - Félkövér ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<i>Szöveg</i>"),
                                                _createTextVNode(" - Dőlt")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<u>Szöveg</u>"),
                                                _createTextVNode(" - Aláhúzott ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<a href=\"url\">Link</a>"),
                                                _createTextVNode(" - Hivatkozás ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<ul><li>Elem</li></ul>"),
                                                _createTextVNode(" - Lista ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<ol><li>Elem</li></ol>"),
                                                _createTextVNode(" - Számozott lista ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<strong>Szöveg</strong>"),
                                                _createTextVNode(" - Erősen kiemelt ")
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("code", null, "<em>Szöveg</em>"),
                                                _createTextVNode(" - Hangsúlyozott ")
                                              ])
                                            ], -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: postEditorToolbarState.value.bold ? 'flat' : 'text',
                                    color: postEditorToolbarState.value.bold ? 'primary' : '',
                                    icon: "mdi-format-bold",
                                    onClick: _cache[63] || (_cache[63] = ($event: any) => (applyEditorCommand('bold')))
                                  }, null, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: postEditorToolbarState.value.italic ? 'flat' : 'text',
                                    color: postEditorToolbarState.value.italic ? 'primary' : '',
                                    icon: "mdi-format-italic",
                                    onClick: _cache[64] || (_cache[64] = ($event: any) => (applyEditorCommand('italic')))
                                  }, null, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: 
                        postEditorToolbarState.value.underline ? 'flat' : 'text'
                      ,
                                    color: postEditorToolbarState.value.underline ? 'primary' : '',
                                    icon: "mdi-format-underline",
                                    onClick: _cache[65] || (_cache[65] = ($event: any) => (applyEditorCommand('underline')))
                                  }, null, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: 
                        postEditorToolbarState.value.unorderedList ? 'flat' : 'text'
                      ,
                                    color: 
                        postEditorToolbarState.value.unorderedList ? 'primary' : ''
                      ,
                                    icon: "mdi-format-list-bulleted",
                                    onClick: _cache[66] || (_cache[66] = ($event: any) => (applyEditorCommand('insertUnorderedList')))
                                  }, null, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: 
                        postEditorToolbarState.value.orderedList ? 'flat' : 'text'
                      ,
                                    color: 
                        postEditorToolbarState.value.orderedList ? 'primary' : ''
                      ,
                                    icon: "mdi-format-list-numbered",
                                    onClick: _cache[67] || (_cache[67] = ($event: any) => (applyEditorCommand('insertOrderedList')))
                                  }, null, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: postEditorToolbarState.value.h2 ? 'flat' : 'text',
                                    color: postEditorToolbarState.value.h2 ? 'primary' : '',
                                    onClick: _cache[68] || (_cache[68] = ($event: any) => (applyEditorCommand('formatBlock', 'h2')))
                                  }, {
                                    default: _withCtx(() => [...(_cache[166] || (_cache[166] = [
                                      _createTextVNode(" H2 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["variant", "color"]),
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: postEditorToolbarState.value.h3 ? 'flat' : 'text',
                                    color: postEditorToolbarState.value.h3 ? 'primary' : '',
                                    onClick: _cache[69] || (_cache[69] = ($event: any) => (applyEditorCommand('formatBlock', 'h3')))
                                  }, {
                                    default: _withCtx(() => [...(_cache[167] || (_cache[167] = [
                                      _createTextVNode(" H3 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["variant", "color"])
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", {
                                    ref_key: "postContentEditor",
                                    ref: postContentEditor,
                                    class: "editor-contenteditable",
                                    contenteditable: "true",
                                    onInput: onEditorInput
                                  }, null, 544)
                                ])
                              ]),
                              _createVNode(_component_v_row, {
                                class: "mb-4",
                                dense: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_text_field, {
                                        modelValue: newPost.value.imageUrl,
                                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((newPost.value.imageUrl) = $event)),
                                        label: "Címlapkép URL-je (opcionális)",
                                        "prepend-inner-icon": "mdi-image-edit-outline",
                                        variant: "outlined"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    md: "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("input", {
                                        id: "imgUpload",
                                        ref_key: "postImagesInput",
                                        ref: postImagesInput,
                                        type: "file",
                                        accept: "image/*",
                                        multiple: "",
                                        onChange: onImageSelect,
                                        style: {"display":"none"}
                                      }, null, 544),
                                      _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_v_btn, {
                                          variant: "outlined",
                                          "prepend-icon": "mdi-upload",
                                          disabled: isBlogPostSubmitting.value,
                                          onClick: _cache[71] || (_cache[71] = ($event: any) => (postImagesInput.value?.click()))
                                        }, {
                                          default: _withCtx(() => [...(_cache[168] || (_cache[168] = [
                                            _createTextVNode(" Képek feltöltése ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["disabled"]),
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(selectedPostImages.value.length) + " fájl kiválasztva ", 1)
                                      ]),
                                      (isBlogPostSubmitting.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, _toDisplayString(selectedPostImages.value.length > 0
                            ? "Képfeltöltés folyamatban... kérlek várj."
                            : "Mentés folyamatban... kérlek várj."), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (imagePreviews.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagePreviews.value, (image, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: `${image}-${index}`,
                                                class: "image-thumb-wrap"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: image,
                                                  alt: "preview",
                                                  class: _normalizeClass(["image-thumb", {
                            'image-thumb--cover':
                              selectedCoverImageIndex.value === index,
                          }])
                                                }, null, 10, _hoisted_32),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(selectedCoverImageIndex.value === index
                              ? "Borítókép"
                              : "Feltöltött kép"), 1),
                                                _createElementVNode("div", _hoisted_34, [
                                                  _createElementVNode("div", _hoisted_35, [
                                                    _cache[169] || (_cache[169] = _createElementVNode("label", { class: "image-config-label" }, "Méret", -1)),
                                                    _createElementVNode("input", {
                                                      type: "number",
                                                      min: "20",
                                                      max: "90",
                                                      class: "image-config-input",
                                                      value: getImageInsertOption(index).width,
                                                      onInput: ($event: any) => (setImageWidthFromEvent(index, $event))
                                                    }, null, 40, _hoisted_36),
                                                    _cache[170] || (_cache[170] = _createElementVNode("span", { class: "image-config-unit" }, "%", -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_37, [
                                                    _createVNode(_component_v_btn, {
                                                      size: "x-small",
                                                      variant: 
                                getImageInsertOption(index).align === 'left'
                                  ? 'flat'
                                  : 'outlined'
                              ,
                                                      onClick: ($event: any) => (setImageAlign(index, 'left'))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[171] || (_cache[171] = [
                                                        _createTextVNode(" Bal ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }, 8, ["variant", "onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      size: "x-small",
                                                      variant: 
                                getImageInsertOption(index).align === 'center'
                                  ? 'flat'
                                  : 'outlined'
                              ,
                                                      onClick: ($event: any) => (setImageAlign(index, 'center'))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[172] || (_cache[172] = [
                                                        _createTextVNode(" Közép ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }, 8, ["variant", "onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      size: "x-small",
                                                      variant: 
                                getImageInsertOption(index).align === 'right'
                                  ? 'flat'
                                  : 'outlined'
                              ,
                                                      onClick: ($event: any) => (setImageAlign(index, 'right'))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[173] || (_cache[173] = [
                                                        _createTextVNode(" Jobb ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }, 8, ["variant", "onClick"])
                                                  ]),
                                                  _createVNode(_component_v_btn, {
                                                    size: "small",
                                                    variant: 
                              selectedCoverImageIndex.value === index
                                ? 'flat'
                                : 'outlined'
                            ,
                                                    color: "primary",
                                                    class: "image-action-btn",
                                                    onClick: ($event: any) => (setCoverImageIndex(index))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(selectedCoverImageIndex.value === index
                                ? "Borítókép"
                                : "Borítónak"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["variant", "onClick"]),
                                                  _createVNode(_component_v_btn, {
                                                    size: "small",
                                                    variant: "flat",
                                                    color: "deep-orange",
                                                    class: "image-action-btn",
                                                    onClick: ($event: any) => (insertImageToEditor(index))
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[174] || (_cache[174] = [
                                                      _createTextVNode(" Beszúrás ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["onClick"])
                                                ]),
                                                _createVNode(_component_v_btn, {
                                                  size: "x-small",
                                                  icon: "mdi-close",
                                                  color: "error",
                                                  class: "image-remove-btn",
                                                  onClick: ($event: any) => (removeSelectedImage(index))
                                                }, null, 8, ["onClick"])
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (imagePreviews.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Tipp: állítsd be a kép méretét/pozícióját a kártyán, majd nyomj `Beszúrás`-t. "))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_combobox, {
                                modelValue: newPost.value.categories,
                                "onUpdate:modelValue": [
                                  _cache[72] || (_cache[72] = ($event: any) => ((newPost.value.categories) = $event)),
                                  onCategoriesUpdate
                                ],
                                items: availableCategories.value,
                                label: "Kategóriák",
                                multiple: "",
                                chips: "",
                                clearable: "",
                                "allow-new": "",
                                "prepend-inner-icon": "mdi-tag-multiple-outline",
                                variant: "outlined",
                                hint: "Több kategória is választható vagy létrehozható",
                                "persistent-hint": ""
                              }, null, 8, ["modelValue", "items"]),
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_v_btn, {
                                  size: "small",
                                  variant: "text",
                                  "prepend-icon": "mdi-tag-remove",
                                  disabled: !blogCategories.value.length,
                                  onClick: _cache[73] || (_cache[73] = ($event: any) => (showCategoryManagerDialog.value = true))
                                }, {
                                  default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                                    _createTextVNode(" Kategóriák kezelése ", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["disabled"])
                              ])
                            ]),
                            _: 1
                          }, 512)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider, { class: "mt-4" }),
                      _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            text: "",
                            disabled: isBlogPostSubmitting.value,
                            onClick: onCancel
                          }, {
                            default: _withCtx(() => [...(_cache[176] || (_cache[176] = [
                              _createTextVNode("Mégse", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            color: "grey",
                            onClick: _cache[74] || (_cache[74] = ($event: any) => (createPost('draft'))),
                            disabled: isBlogPostSubmitting.value,
                            loading: isBlogPostSubmitting.value
                          }, {
                            default: _withCtx(() => [...(_cache[177] || (_cache[177] = [
                              _createTextVNode(" Mentés piszkozatként ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled", "loading"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "flat",
                            onClick: _cache[75] || (_cache[75] = ($event: any) => (createPost('published'))),
                            disabled: 
                  !newPost.value.title || !newPost.value.content || isBlogPostSubmitting.value
                ,
                            loading: isBlogPostSubmitting.value
                          }, {
                            default: _withCtx(() => [...(_cache[178] || (_cache[178] = [
                              _createTextVNode(" Publikálás ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_dialog, {
                modelValue: showCategoryManagerDialog.value,
                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((showCategoryManagerDialog).value = $event)),
                "max-width": "560"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => [...(_cache[179] || (_cache[179] = [
                          _createTextVNode("Kategóriák kezelése", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          (!blogCategories.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Nincs törölhető kategória. "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blogCategories.value, (category) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: category.id,
                                    class: "d-flex justify-space-between align-center"
                                  }, [
                                    _createVNode(_component_v_chip, {
                                      color: "primary",
                                      variant: "tonal"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(category.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_btn, {
                                      icon: "mdi-delete",
                                      size: "small",
                                      color: "error",
                                      variant: "text",
                                      disabled: isCategoryDeleting.value,
                                      onClick: ($event: any) => (deleteBlogCategory(category))
                                    }, null, 8, ["disabled", "onClick"])
                                  ]))
                                }), 128))
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            variant: "text",
                            onClick: _cache[77] || (_cache[77] = ($event: any) => (showCategoryManagerDialog.value = false))
                          }, {
                            default: _withCtx(() => [...(_cache[180] || (_cache[180] = [
                              _createTextVNode(" Bezárás ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_router_view),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alert.value.text, (error, index) => {
                return (_openBlock(), _createBlock(_component_v_alert, {
                  key: index,
                  border: "end",
                  "border-color": "error",
                  elevation: "2",
                  dismissible: true,
                  autoDismiss: true,
                  dismissTimeout: 5000
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(error), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_AppSnackbar, {
                modelValue: snackbar.value.showing,
                "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((snackbar.value.showing) = $event)),
                color: snackbar.value.color,
                title: snackbar.value.title,
                text: snackbar.value.text
              }, null, 8, ["modelValue", "color", "title", "text"]),
              _createVNode(_component_AppConfirmDialog, {
                modelValue: confirmDialog.value.showing,
                "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((confirmDialog.value.showing) = $event)),
                title: confirmDialog.value.title,
                text: confirmDialog.value.text,
                "confirm-text": confirmDialog.value.confirmText,
                "cancel-text": confirmDialog.value.cancelText,
                color: confirmDialog.value.color,
                icon: confirmDialog.value.icon,
                onConfirm: _cache[81] || (_cache[81] = ($event: any) => (_unref(store).dispatch('resolveConfirmDialog', true))),
                onCancel: _cache[82] || (_cache[82] = ($event: any) => (_unref(store).dispatch('resolveConfirmDialog', false)))
              }, null, 8, ["modelValue", "title", "text", "confirm-text", "cancel-text", "color", "icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (profile.value?.username)
        ? (_openBlock(), _createBlock(_component_v_bottom_navigation, {
            key: 0,
            class: "d-md-none mobile-bottom-nav",
            "bg-color": "surface",
            grow: "",
            elevation: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                active: isRouteActive(['forum-page', 'blog-post-page', 'BlogEdit']),
                onClick: _cache[83] || (_cache[83] = ($event: any) => (_unref(router).push({ name: 'forum-page' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[181] || (_cache[181] = [
                      _createTextVNode("mdi-post-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[182] || (_cache[182] = _createTextVNode(" Blog ", -1))
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_v_btn, {
                active: isRouteActive(['games-page', 'games-page-legacy-detail']),
                onClick: _cache[84] || (_cache[84] = ($event: any) => (_unref(router).push({ name: 'games-page' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[183] || (_cache[183] = [
                      _createTextVNode("mdi-gamepad-variant-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[184] || (_cache[184] = _createTextVNode(" Játékok ", -1))
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_v_btn, {
                active: isRouteActive(['maps-page']),
                onClick: _cache[85] || (_cache[85] = ($event: any) => (_unref(router).push({ name: 'maps-page' })))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[185] || (_cache[185] = [
                      _createTextVNode("mdi-map-marker-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[186] || (_cache[186] = _createTextVNode(" Pályák ", -1))
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_v_btn, {
                active: isRouteActive(['profile-page']),
                onClick: goToProfile
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[187] || (_cache[187] = [
                      _createTextVNode("mdi-account-circle-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[188] || (_cache[188] = _createTextVNode(" Profil ", -1))
                ]),
                _: 1
              }, 8, ["active"]),
              _createVNode(_component_v_btn, {
                active: drawer.value,
                onClick: _cache[86] || (_cache[86] = ($event: any) => (drawer.value = !drawer.value))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[189] || (_cache[189] = [
                      _createTextVNode("mdi-menu", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[190] || (_cache[190] = _createTextVNode(" Menü ", -1))
                ]),
                _: 1
              }, 8, ["active"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})